import { CLIENT_CREATE_ALLOWED_ROLES } from '@/lib/capabilities';
import { B2G_VIEW_ROLES, canViewB2gData } from '../b2g-access';
import { REVIEWED_IMPORT_OPERATIONAL_SQL_ROLES } from './operational-roles';

export { REVIEWED_IMPORT_OPERATIONAL_SQL_ROLES } from './operational-roles';

/** P01 UX03/UX04 intake surfaces — manual intake remains available without import. */
export const REVIEWED_IMPORT_INTAKE_ROLES = Object.freeze(
  [
    ...new Set([
      ...CLIENT_CREATE_ALLOWED_ROLES,
      ...B2G_VIEW_ROLES,
      ...REVIEWED_IMPORT_OPERATIONAL_SQL_ROLES,
    ]),
  ].filter((role) => !['OWNER', 'SYSTEM_ADMIN', 'TENANT_ADMIN'].includes(role)),
);

const PRIVILEGED_CONFIGURATION_ROLES = new Set(['OWNER', 'SYSTEM_ADMIN', 'TENANT_ADMIN']);

/**
 * My Aged Care client-record import (owner decision 25 Sep 2026): intake staff
 * and the B2G view roles may use it; privileged configuration accounts may not
 * (FNDN-160). QI and 24x7 RN reporting keep the stricter B2G matrix.
 */
export function canAccessReviewedImportIntake(role: string | null | undefined): boolean {
  if (!role || PRIVILEGED_CONFIGURATION_ROLES.has(role)) return false;
  return (REVIEWED_IMPORT_INTAKE_ROLES as readonly string[]).includes(role) || canViewB2gData(role);
}

/** Mirrors the SQL role gate in the reviewed-import lifecycle RPCs exactly. */
export function canExecuteReviewedImportRpc(role: string | null | undefined): boolean {
  if (!role || PRIVILEGED_CONFIGURATION_ROLES.has(role)) return false;
  return (REVIEWED_IMPORT_OPERATIONAL_SQL_ROLES as readonly string[]).includes(role);
}

export function isPrivilegedConfigurationAccount(role: string | null | undefined): boolean {
  if (!role) return false;
  return PRIVILEGED_CONFIGURATION_ROLES.has(role);
}
